import Plugin from 'src/plugin-system/plugin.class';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
 
export default class MobileColorSlidesPlugin extends Plugin {

    init() {
        gsap.registerPlugin(ScrollTrigger);

        var slides = gsap.utils.toArray(".mobile-color-slides-widget__slide");

        slides.forEach((slide, i) => {
            var end = false;

            if (i+1 == slides.length) {
                end = "bottom bottom";
            }

            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "top top", 
                    pin: true, 
                    end: end,
                    markers: false,
                    pinSpacing: false,
                }
            });

        });
          
    }

}